// src/components/SkeletonTable.jsx
import React from "react";

function SkeletonTable({ rows = 5, columns = 5 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <tr key={rowIndex} className="animate-pulse">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <td key={colIndex} className="px-6 py-4">
              <div className="h-4 w-full max-w-[120px] bg-gray-300 dark:bg-gray-600 rounded"></div>
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}

export default SkeletonTable;
